
import AccordionItem from './AccordionItem'
import React from "react";
import ReactDOM from "react-dom";

class Accordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        itemsShown:0,
        itemsTotal:0,
        openItem:0,
        closeAll:true
        };
  }
 

  componentDidUpdate(prevProps,prevState){
    if(prevProps.items.length != this.props.items.length)
    {
        let limit = this.props.limit ? parseInt(this.props.limit) : this.props.items.length;
        this.setState(
            {  
                itemsShown: limit,
                itemsTotal: this.props.items.length
            }
        )
    }
    if(prevProps.openItem != this.props.openItem)
    {
        this.setState(
            {  
                openItem: this.props.openItem,
                closeAll:true
                
            }
        )
    }

  }
  showMoreHandler=()=>{
      event.preventDefault();
      const itemsToShow = Math.min(this.state.itemsShown +  parseInt(this.props.limit), this.state.itemsTotal);
      this.setState(
          {
              itemsShown: itemsToShow
          }
      )
  }
  render() {
    let accItem = null;
    let footer= null;
    let items = [...this.props.items].slice(0,this.state.itemsShown);
    if(this.props.type == "Faq"){
        if(this.props.layout == "first"){ //rich text items -faq
            accItem = <div className=" accordion" id={"accordionItem_"+ this.props.WpId}>
                {this.props.items.map((item,index) => 
                <AccordionItem data={item} index={index} WpId={this.props.WpId} 
                layout={this.props.layout} Title={item.Title} type={this.props.type} key={"accordion_"+index+""+ this.props.WpId} 
                 handleUserKeypress = {this.props.handleUserKeypress}/>
                ) }
            </div>
        }
        else if(this.props.layout == "second"){ // categories
            const obj = this.props.items.reduce(function (temp, item) {
                if (!temp[item.MODFooterCategory]) temp[item.MODFooterCategory] = []
                temp[item.MODFooterCategory].push(item);
                return temp;
            }, Object.create(null));
            accItem = Object.keys(obj).sort().map((key,index) => {
                return <AccordionItem data={obj[key]} index={index} WpId={this.props.WpId} layout={this.props.layout}
                 Title={key.split(":")[1]} type={this.props.type} key={"AccordionItem_"+index}
                 handleUserKeypress = {this.props.handleUserKeypress}/>
                })  
        }
    }
    else if(this.props.type == "News"){ //rich text items -news
        if(this.props.layout == "first"){
            accItem = <div className=" accordion col-12 col-md-8" id={"accordionItem_"+ this.props.WpId}>
                {items.map((item,index) => 
                <AccordionItem data={item} index={index} WpId={this.props.WpId} layout={this.props.layout} 
                Title={item.Title} type={this.props.type} openItem={this.props.openItem} key={"AccordionItem_"+index}
                handleUserKeypress = {this.props.handleUserKeypress}/>
                ) }
            </div>;
            footer= this.state.itemsShown < this.state.itemsTotal ?  <div className="faqFooter">
                <div className="readMoreDiv NewsLink">
                    <div  className="readMoreLink" onClick={this.showMoreHandler}>{this.props.moreTitle}<i className="fa fa-arrow-down" aria-hidden="true"></i></div>
                </div>
            </div>: null;
        }
    }
    else if(this.props.type == "Form"){ //Categories
        const obj = this.props.items.reduce(function (temp, item) {
                if (!temp[item.MODFooterCategory]) temp[item.MODFooterCategory] = []
                temp[item.MODFooterCategory].push(item);
                return temp;
            }, Object.create(null));
            accItem = Object.keys(obj).map((key,index) => {
                return <AccordionItem data={obj[key]} index={index} WpId={this.props.WpId} layout={this.props.layout} Title={key.split(":")[1]} type={this.props.type} key={"AccordionItem_"+index}/>
                })
    }
    else if(this.props.type == "Event"){ //rich text items - Events
        accItem = <div className=" accordion col-12" id={"accordionItem_"+ this.props.WpId}>
            {items.map((item,index) => 
            <AccordionItem data={item} index={index} WpId={this.props.WpId} layout={this.props.layout} Title={item.Title} type={this.props.type} 
            openItem={this.props.openItem} closeAll={this.state.closeAll} key={"AccordionItem_"+index}  handleUserKeypress = {this.props.handleUserKeypress} />
            ) }
        </div>;
    }
    else if(this.props.type == "ContactUs"){ //
        const obj = this.props.items.reduce(function (temp, item) {
            if (!temp[item.MODContactsCategory]) temp[item.MODContactsCategory] = []
            temp[item.MODContactsCategory].push(item);
            return temp;
        }, Object.create(null));
        accItem = Object.keys(obj).sort().map((key,index) => {
                return <AccordionItem data={obj[key]} index={index} WpId={this.props.WpId} 
                        layout={this.props.layout} Title={key} type={this.props.type} key={"AccordionItem_"+index}
                        handleUserKeypress = {this.props.handleUserKeypress} />
                })
        // accItem = <div className=" accordion col-12 col-md-8" id={"accordion_"+ this.props.WpId}>
        //   { this.props.items.map((item,index) => 
        //      <AccordionItem data={item} index="1" WpId={this.props.WpId} layout={this.props.layout} 
        //         Title="מחוזות אגף משפחות והנצחה" type={this.props.type} openItem={this.props.openItem}/>
        //     ) }
        // </div>;
    }
    return (
        <React.Fragment>
            <div id={"modAccordion_"+this.props.WpId} className="modAccordion">
                {accItem}
            </div>
            {footer}
        </React.Fragment>
      );
    }
}
export default Accordion; 